import { Routes } from '@angular/router';

export const USUARIOS_ROUTES: Routes = [
    {
        path: 'listar',
        loadComponent: () =>
            import('./listar/listar-usuario')
                .then(m => m.ListarUsuario)
    },
    {
        path: 'crear',
        loadComponent: () =>
            import('./crear/crear')
                .then(m => m.Crear)
    },
    {
        path: 'editar/:id',
        loadComponent: () =>
            import('./editar/editar')
                .then(m => m.Editar)
    }
    

];
